import script from "./Company.vue?vue&type=script&lang=ts&setup=true"
export * from "./Company.vue?vue&type=script&lang=ts&setup=true"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./Company.vue?vue&type=style&index=1&id=708029e1&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-708029e1"]])

export default __exports__